<script setup>
import {computed, onMounted, ref} from 'vue'
import Content from "@/components/Content/Content.vue";
import axios from "axios";
import {useStore} from "vuex";
import Tab from "@/pages/Index/components/Tab.vue";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";
import MoreButton from "@/pages/Index/components/MoreButton.vue";
import {useRouter} from "vue-router";

const store = useStore()
const router = useRouter()

const category = ref([])
const activeTab = ref(null)

const currentLang = computed(() => store.getters.currentLanguage)

const tabList = computed(() =>{
	return category.value.map(item => {
		return {
			label: item?.[`text_${currentLang.value}`],
			value: item?.id
		}
	})
})

const currentProduct = computed(() => {
	return category.value.find(item => item?.id === activeTab.value)
})

const getProductCategory = async () => {
	const res = await axios.get('api/api/category')
		.catch(err => {
			throw new Error(err.message)
		})
	
	console.log('res getProductCategory--------->', res)
	category.value = res.data
	activeTab.value = res.data[0].id
}

const handleToDetails = () => {
	router.push(`/productDisplay?tab=${activeTab.value}`)
}

onMounted(() => {
	getProductCategory()
})
</script>

<template>
	<div class="product">
		<Content
			:title="$t('section.products.title')"
			mode="dark"
		>
			<div class="product__warp">
				<div class="product__content">
					<div class="product__content__icon">
<!--						<SvgIcon name="car" class-name="icon" />-->
						<img
							:src="currentProduct?.icon"
							class="icon"
						/>
					</div>
					
					<div class="product__content__title">
						{{ currentProduct?.[`text_${currentLang}`] }}
					</div>
					
					<div class="product__content__desc">
						{{ currentProduct?.[`describe_${currentLang}`] || '-' }}
					</div>
					
					<div class="product__content__more">
						<MoreButton
							:btnText="$t('section.products.more')"
							:custom-style="{
								'background-color': '#DA241B',
								'color': '#FFFFFF',
								'border-color': '#DA241B'
							}"
							@click="handleToDetails"
						/>
					</div>
				</div>
				
				<div class="product__image">
					<div class="product__image__image">
						<img :src="currentProduct?.image" />
					</div>
					
					<div class="product__image__shadow" />
				</div>
			</div>
			
			
			<div class="tab--pc">
				<Tab
					:list="tabList"
					v-model="activeTab"
				/>
			</div>
			
			<div class="tab--mobile">
				<el-tabs v-model="activeTab">
					<el-tab-pane
						v-for="(item, index) in tabList"
						:label="item.label"
						:name="item.value"
					/>
				</el-tabs>
			</div>
			
		</Content>
	</div>
</template>

<style scoped lang="less">
.product {
	padding: 72px 0 64px 0;
	
	.tab--mobile {
		display: none;
	}
	
	&__warp {
		display: flex;
		justify-content: space-between;
	}
	
	&__content {
		width: 40%;
		&__icon {
			
			.icon {
				width: 64px;
				height: 64px;
			}
			
		}
		
		&__title {
			margin-top: 12px;
			font-size: 32px;
			font-weight: bold;
			color: #303133;
		}
		
		&__desc {
			margin: 32px 0;
			font-size: 18px;
			line-height: 32px;
			color: #909399;
		}
		
		&__more {
			display: flex;
		}
	}
	
	&__image {
		position: relative;
		&__image {
			transition: all .3s;
			width: 450px;
			height: 450px;
			&:hover {
				transform: scale(1.2);
			}
			
			> img {
				width: 100%;
				height: 100%;
			}
		}
		
		
		
		&__shadow {
			position: absolute;
			left: 0;
			bottom: 10px;
			width: 100%;
			padding: 20px;
			background: radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
			filter: blur(20px);
		}
		
	}
	
	::v-deep(.el-tabs__item) {
		color: #909399;
		font-size: 20px;
		
		.is-active {
			font-weight: bold;
		}
		
	}
	
	::v-deep(.el-tabs__nav) {
		padding-bottom: 16px;
		
		.is-active {
			color: @primary-color;
			font-weight: bold;
		}
		
		.el-tabs__active-bar {
			background-color: @primary-color;
		}
	}
}

@media only screen and (max-width: 1024px) {
	.product {
		padding: 30px 0;
	}
}

@media only screen and (max-width: 768px) {
	.product {
		
		&__warp {
			flex-direction: column;
		}
		
		.tab--pc {
			display: none;
		}
		
		.tab--mobile {
			margin-top: 20px;
			display: block;
		}
		
		&__content {
			width: 100%;
			
			&__icon {
				display: none;
				.icon {
					width: 40px;
					height: 40px;
				}
				
			}
			
			&__title {
				margin-top: 0;
				font-size: 18px;
				font-weight: bold;
				color: #303133;
			}
			
			&__desc {
				margin: 8px 0 20px 0;
				font-size: 16px;
				line-height: 28px;
			}
			
			&__more {
				justify-content: center;
			}
		}
		
		&__image {
			margin-top: 20px;
			display: flex;
			justify-content: center;
			
			&__image {
				width: 300px;
				height: 300px;
				
				> img {
					width: 100%;
					height: 100%;
				}
			}
			
			&__shadow {
				padding: 0;
				height: 38px;
			}
		}
		
		::v-deep(.el-tabs__item) {
			color: #909399;
			font-size: 18px;
			
		}
	}
}
</style>